// countrySelector.js
export const COUNTRY_CODES = {
  AR: { code: "+54", emoji: "🇦🇷", length: 10 },
  BO: { code: "+591", emoji: "🇧🇴", length: 8 },
  BR: { code: "+55", emoji: "🇧🇷", length: 11 },
  CL: { code: "+56", emoji: "🇨🇱", length: 9 },
  CO: { code: "+57", emoji: "🇨🇴", length: 10 },
  CR: { code: "+506", emoji: "🇨🇷", length: 8 },
  CU: { code: "+53", emoji: "🇨🇺", length: 8 },
  DO: { code: "+1", emoji: "🇩🇴", length: 10 },
  EC: { code: "+593", emoji: "🇪🇨", length: 9 },
  SV: { code: "+503", emoji: "🇸🇻", length: 8 },
  GT: { code: "+502", emoji: "🇬🇹", length: 8 },
  HN: { code: "+504", emoji: "🇭🇳", length: 8 },
  MX: { code: "+52", emoji: "🇲🇽", length: 10 },
  NI: { code: "+505", emoji: "🇳🇮", length: 8 },
  PA: { code: "+507", emoji: "🇵🇦", length: 8 },
  PY: { code: "+595", emoji: "🇵🇾", length: 9 },
  PE: { code: "+51", emoji: "🇵🇪", length: 9 },
  PR: { code: "+1", emoji: "🇵🇷", length: 10 },
  UY: { code: "+598", emoji: "🇺🇾", length: 8 },
  VE: { code: "+58", emoji: "🇻🇪", length: 10 },
  ES: { code: "+34", emoji: "🇪🇸", length: 9 },
  US: { code: "+1", emoji: "🇺🇸", length: 10 },
};
